<!-- <div class="modal-content">
  <div class="modal-body"> -->
<!-- Manual de orientaçao para contratação de plano de saúde -->
<section>
  <app-manual-orientacao-proposta
    [dadosOperadoraDM]="dadosOperadoraDM"
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
    [tipoProduto]="tipoProduto"></app-manual-orientacao-proposta>
</section>
<!-- Formulário do Beneficiário -->
<section>
  <app-formulario-beneficiario-proposta
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
    [dadosOperadoraDM]="dadosOperadoraDM"
    [tipoProduto]="tipoProduto"
    [entidadeProposta]="entidadeProposta"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [heMedSenior]="heMedSenior"
    [listaBeneficiariosFormulario]="listaBeneficiariosFormulario"></app-formulario-beneficiario-proposta>
</section>
<!-- Dados Bancários  -->
<section>
  <app-formulario-dados-bancarios-proposta
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
    [dadosOperadoraDM]="dadosOperadoraDM"
    [entidadeProposta]="entidadeProposta"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [nomeTitular]="nomeTitular"
    [tipoPlano]="tipoPlano"
    [tipoRegistroProduto]="tipoRegistroProduto"
    [ansProduto]="ansProduto"
    [acomadacaoPlano]="acomadacaoPlano"
    [dataAssinaturaDadosBancarios]="dataAssinaturaDadosBancarios"
    [horaAssinaturaDadosBancarios]="horaAssinaturaDadosBancarios"
    [totalPlano]="totalPlano"
    [totalPlanoComTaxa]="totalPlanoComTaxa"
    [beneficiarios]="beneficiarios"
    [cpfTitular]="cpfTitular"
    [heMedSenior]="heMedSenior"
    [valorRecebidoPeloBeneficiario]="valorRecebidoPeloBeneficiario"></app-formulario-dados-bancarios-proposta>

  <app-assinatura-documento
    [nomeTitular]="nomeTitular"
    [dataAssinatura]="dataAssinaturaDadosBancarios"
    [horaAssinatura]="horaAssinaturaDadosBancarios"
    [nomeCorretora]="nomeCorretora"
    [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
</section>
<!-- Proposta adesão UNIMED FESP -->
<section *ngIf="!heMedSenior">
  <div class="documento-aditivo-container espacamento-mobile alinhamento-texto-mobile">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>

    <h3
      class="titulo text-center bold-preto-700 mb-1"
      style="padding: 0.5rem; background: black; color: #fff; border-radius: 10px">
      PROPOSTA DE ADESÃO UNIMED FESP
    </h3>
    <p class="mb-1">
      Pelo presente instrumento, solicito a minha adesão e dos dependentes por mim relacionados, como BENEFICIÁRIO do
      CONTRATO DE PLANO DE SAÚDE , firmado em 01/06/2009, entre a administradora de benefícios ADMSERV BENEFÍCIOS E
      SERVIÇOS LTDA de nome fantasia Géia Administradora de Benefícios, registrada na Agência Nacional de Saúde
      Suplementar-ANS, sob o número 416932, inscrita no CNPJ/MF sob o nº 07.867.825/0001-57, com sede à Av. Valdemar
      Ferreira, 463 - Butantã, São Paulo - SP, CEP: 05501-000, doravante denominado ESTIPULANTE e a operadora de planos
      de saúde UNIMED FESP, registrada na Agência Nacional de Saúde Suplementar-ANS sob o número 319996 e no CNPJ/MF sob
      nº 43.643.139/0001-66, m endereço à Rua José Getúlio, 78/90- Aclimação - São Paulo - SP - CEP: 01509-000,
      denominada CONTRATADA, em razão do vínculo de caráter profissional, classista ou setorial que possuo com a
      Entidade de Classe, citada no anverso desta proposta, denominada ENTIDADE ADERENTE.
    </p>
    <ul>
      <li>
        <p class="m-2">
          1. Para a formalização da presente adesão, o BENEFICIÁRIO declara ter completo conhecimento de todas as
          condições estabelecidas no CONTRATO celebrado entre o ESTIPULANTE E A CONTRATADA, concordando com as mesmas e
          afirmando que não existe qualquer dúvida a respeito do plano de saúde escolhido.
        </p>
      </li>
      <li>
        <p class="m-2">
          2. O BENEFICIÁRIO afirma ter ciência que o plano de saúde ao qual pede sua adesão será administrado pelo
          ESTIPULANTE, que se responsabilizará pelo cadastro, inclusão, cancelamentos e exclusão de beneficiários, além
          da gestão financeira do plano, faturamento e cobrança das mensalidades.
        </p>
      </li>
      <li>
        <p class="m-2">
          3. Novas inclusões de BENEFICIÁRIOS DEPENDENTES deverão ser solicitadas pelo BENEFICIÁRIO TITULAR junto ao
          ESTIPULANTE e seguirão as mesmas regras de vigência do BENEFICIÁRIO TITULAR.
        </p>
      </li>
      <li>
        <p class="m-2">
          4. Para os casos de RN (recém-nascido) e RC (recém-casados) o prazo será de 30 dias contados da data do evento
          para que tenha as mesmas condições de carências do titular transcorrido este prazo as inclusões serão
          processadas com o cumprimento das carências contratadas.
        </p>
      </li>
      <li>
        <p class="m-2">
          5. Para solicitar eventuais exclusões de beneficiários dependentes ou o cancelamento da sua adesão, o
          BENEFICIÁRIO TITULAR, compromete-se a comunicar, através dos canais de comunicação disponibilizados pela
          ESTIPULANTE e CONTRATADA, em cumprimento à Resolução Normativa editada pela Agência Nacional de Saúde
          Suplementar, RN nº 561/2022, sua intenção, opção esta que surtirá efeito de forma imediata e terá caráter
          irrevogável e irretratável.
        </p>
      </li>
      <li>
        <p class="m-2">
          6. O BENEFICIÁRIO TITULAR assume o compromisso de realizar pontualmente o pagamento do valor da mensalidade,
          por si e por seus dependentes, com vencimento todo 5º dia útil de cada mês, através de débito em conta
          corrente, desde que devidamente autorizado na presente proposta de adesão.
        </p>
      </li>
      <li>
        <p class="m-2">
          7. Afirma o BENEFICIÁRIO TITULAR ter ciência de que na hipótese de impontualidade no pagamento da mensalidade
          serão cobrados juros de mora de 1% (um por cento) ao mês, calculados proporcionalmente ao tempo de atraso,
          além de multa moratória de 2% (dois por cento) incidente sobre ovalor do débito atualizado.
        </p>
      </li>
      <li>
        <p class="m-2">
          8. Declara o BENEFICIÁRIO TITULAR possuir completo conhecimento de que os valores das mensalidades serão
          reajustados conforme a sinistralidade apurada, bem como na ocasião de mudança de faixa etária, na forma
          prevista pelo CONTRATO DE PLANO DE SAÚDE celebrado entre ESTIPULANTE e a CONTRATADA e também prevista no
          MANUAL DE ORIENTAÇÃO PARA CONTRATAÇÃO DE PLANO DE SAÚDE - MPS.
        </p>
      </li>
      <li>
        <p class="m-2">
         9. Declara o BENEFICIÁRIO TITULAR ter conhecimento de que será excluído do presente contrato em caso de perda da elegibilidade e nos casos de inadimplemento, atrasando o pagamento de duas mensalidades, consecutivas ou não, no período de 12 (doze)) meses, desde que seja cientificado da inadimplência conforme RN 593, oportunidade em que será concedido prazo de 10 (dez) dias para regularização do débito, sem prejuízo do direito de lhe ser requerida judicialmente a quitação do débito com suas consequências moratórias.
         § 1º: No
          caso do cancelamento do plano contratado, haverá a exclusão do BENEFICIÁRIO TITULAR e dos BENEFICIÁRIOS
          DEPENDENTES, quando houver, sem prejuízo da cobrança dos valores em aberto com seus respectivos encargos. §
          2º: O ESTIPULANTE utilizará todos os meios admitidos em direito para satisfação de seu crédito, inclusive
          proceder com a inscrição do BENEFICIÁRIO inadimplente nos órgãos de proteção ao crédito, a seu critério e
          conveniência.
        </p>
      </li>
      <li>
        <p class="m-2">
          10. O BENEFICIÁRIO afirma ter ciência que também será excluído do plano de saúde em casos de fraude,
          declaração de informações falsas, incompletas ou omissões, como também na hipótese de utilização indevida do
          cartão de identificação, ou seja, se vier a autorizar terceiros a utilizar o seu cartão de identificação para
          realização de quaisquer procedimentos, sem prejuízo do ESTIPULANTE e da CONTRATADA adotarem as medidas
          judiciais cabíveis para se ressarcir dos danos sofridos.
        </p>
      </li>
      <li>
        <p class="m-2">
          11. Declara ainda o BENEFICIÁRIO TITULAR, ter ciência que na hipótese da sua exclusão, todos os seus
          dependentes incluídos no plano de saúde, serão automaticamente excluídos.
        </p>
      </li>
      <li>
        <p class="m-2">
          12. Declara o BENEFICIÁRIO TITULAR ter conhecimento que a responsabilidade pela prestação dos atendimentos
          ambulatoriais, hospitalares e obstétricos é exclusiva dos profissionais e instituições a serviço da
          CONTRATADA.
        </p>
      </li>
      <li>
        <p class="m-2">
          13. O BENEFICIÁRIO outorga ao ESTIPULANTE, procuração, para que a mesma possa representá-lo e a seus
          dependentes perante a CONTRATADA e Agência Nacional de Saúde Suplementar (ANS)., no cumprimento das cláusulas
          previstas no CONTRATO DE PLANO DE SAÚDE.
        </p>
      </li>
      <li>
        <p class="m-2">
          14. Será entregue o CARTÃO DE IDENTIFICAÇÃO ao BENEFICIÁRIO TITULAR E SEUS DEPENDENTES em tempo hábil para
          usufruto do plano de saúde, cuja confecção e expedição é de inteira responsabilidade da CONTRATADA. Quaisquer
          omissões ou erros registrados na confecção deverão ser imediatamente comunicados a ESTIPULANTE, para as
          devidas providências. Na hipótese de exclusão de dependentes ou cancelamento da adesão, o BENEFICIÁRIO ficará
          responsável pelo recolhimento e devolução dos CARTÕES DE IDENTIFICAÇÃO à ESTIPULANTE.
        </p>
      </li>
      <li>
        <p class="m-2">
          15. O não cumprimento das obrigações do BENEFICIÁRIO previstas neste instrumento e no Contrato Padrão, bem
          como a utilização indevida do cartão após o cancelamento solicitado ou por inadimplência, autoriza a adoção de
          medidas judiciais por parte da ESTIPULANTE e da CONTRATADA, para a cobrança de eventuais prejuízos que vierem
          a ser apurados.
        </p>
      </li>
    </ul>
    <h3
      class="titulo text-justify bold-preto-700 mt-2"
      style="padding: 0.5rem; background: black; color: #fff; border-radius: 10px">
      Declaro ter lido e estar de acordo com os itens acima, declaro ter lido o Manual de Orientação para Contratação do
      Plano de Saúde (MPS), cópia da Proposta de Adesão e da Declaração de Saúde, parte integrante deste documento e à
      disposição do beneficiário na área logada. Declaro ainda estar ciente de que o cartão de identificação do
      beneficiário será encaminhado porteriormente, após a confrecção.
    </h3>

    <app-assinatura-documento
      [nomeTitular]="nomeTitular"
      [dataAssinatura]="dataAssinaturaDocFinal"
      [horaAssinatura]="horaAssinaturaDocFinal"
      [nomeCorretora]="nomeCorretora"
      [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
  </div>
</section>
<!-- Carta de Orientação ao Beneficiário -->
<section>
  <div class="rodape-sem-quebra documento-aditivo-container espacamento-mobile">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>

    <app-carta-orientacao-beneficiario
      [nomeTitular]="nomeTitular"
      [dataAssinaturaCartaOrientacaoDS]="dataAssinaturaCartaOrientacaoDS"
      [horaAssinaturaCartaOrientacaoDS]="horaAssinaturaCartaOrientacaoDS"
      [nomeCorretora]="nomeCorretora"
      [nomeVendedor]="nomeVendedor"></app-carta-orientacao-beneficiario>
  </div>
</section>
<!-- informações Importantes -->
<section>
  <div class="nova-pagina documento-aditivo-container espacamento-mobile alinhamento-texto-mobile">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>

    <h3 class="titulo text-center bold-preto-700 mb-1 p-1" style="background: #ccc; border-radius: 10px">
      Informações Importantes
    </h3>
    <ul>
      <li>
        <p class="m-2">
          1. No preenchimento desta declaração, o consumidor tem a opção de ser orientado, sem ônus financeiro, por um
          médico indicado pela Operadora; ou por um de sua confiança, neste caso as despesas com honorários serão de sua
          responsabilidade.
        </p>
      </li>
      <li>
        <p class="m-2">
          2. A Declaração de Saúde tem por objetivo registrar a existência de doenças e lesões preexistentes, como sendo
          aquelas que o consumidor tenha conhecimento no momento da assinatura do contrato, em relação a si próprio ou a
          qualquer de seus dependentes.
        </p>
      </li>
      <li>
        <p class="m-2">
          3.
          <b>No momento da adesão</b>
          , havendo declaração de doença ou lesão preexistente, podem ser oferecidas duas opções:
        </p>
        <ul class="ml-3 mr-3">
          <li>
            a.
            <b>Cobertura Parcial Temporária:</b>
            o consumidor não terá direito a cirurgias, procedimentos de alta complexidade, ou leitos de alta tecnologia
            relacionados à doença ou lesão declarada, por um período de 24 (vinte e quatro) meses.
          </li>
          <li *ngIf="!heMedSenior">
            b.
            <b>Agravo:</b>
            acréscimo no preço mensal do plano, pelo período de 24 (vinte e quatro) meses, para que o consumidor tenha
            direito à cobertura completa da doença ou lesão preexistente declarada, após os prazos de carências
            contratuais.
            <b>
              <u>
                Esta operadora de planos privados de assistência à saúde não trabalha com o oferecimento de Agravo
                (artigo 6º RN 162 de 2007).
              </u>
            </b>
          </li>
        </ul>
      </li>
      <li>
        <p class="m-2">
          4. A Declaração de Condições de Saúde deve ser preenchida de próprio punho pelo
          <b>BENEFICIÁRIO TITULAR.</b>
          <span *ngIf="!heMedSenior">
            se maior de 18 anos, em nome próprio e de seus BENEFICIÁRIOS DEPENDENTES ou pelo responsável, se o
            BENEFICIÁRIO TITULAR for menor de 18 anos ou incapaz
          </span>
        </p>
      </li>
      <li>
        <p class="m-2">
          5. Toda resposta afirmativa deve ser esclarecida, informando a ocorrência (doença, lesão ou deficiência,
          tratamento ou cirurgia realizados ou a realizar e problema de saúde), a data da constatação da doença que o
          <b>BENEFICIÁRIO</b>
          se refere.
        </p>
      </li>
      <li>
        <p class="m-2">
          6. Nenhuma cobertura poderá ser negada ao consumidor para doenças ou lesões preexistentes não declaradas, até
          que a Operadora apresente as provas concretas junto à ANS de que o consumidor omitiu a doença ou lesão no
          preenchimento desta declaração. ATÉ DECISÃO DA ANS NÃO HAVERÁ SUSPENSÃO DO CONTRATO NEM DO ATENDIMENTO.
        </p>
      </li>
      <li>
        <p class="m-2">
          7.
          <b>
            A omissão de informação sobre a existência de doença ou lesão preexistente da qual o consumidor saiba ser
            portador no momento do preenchimento dessa declaração, desde que comprovada junto à ANS, pode acarretar a
            suspensão ou cancelamento do contrato. Nesse caso, o consumidor será responsável pelas despesas realizadas
            no tratamento da doença ou lesão omitida, a partir da data em que tiver recebido comunicado ou notificação
            da operadora alegando a existência de doença ou lesão preexistente não declarada.
          </b>
        </p>
      </li>
    </ul>
  </div>
</section>
<!-- INfo referente a medSenior inicio   -->

<ng-container *ngIf="heMedSenior">
  <!-- Cabeçalho do documento -->
  <div class="nova-pagina">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="dataVigencia"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>

    <app-documento-final-medsenior
      [dadosProposta]="dadosProstaCompletos"
      [operadoraVM]="operadoraVM"
      [entidadeProposta]="entidadeProposta"
      [codigoProposta]="codigoProposta"
      [dataVigencia]="vigenciaProposta"
      [dataAssinatura]="dataAssinaturaDadosBancarios"
      [nomeBeneficiario]="nomeTitular"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
      [nomeVendedor]="nomeVendedor"
      [nomeCorretora]="nomeCorretora"
      [horaAssinatura]="horaAssinaturaDadosBancarios"></app-documento-final-medsenior>
  </div>
</ng-container>
<!-- ifnor referente a medSenior Fim -->

<ng-container *ngIf="!heMedSenior">
  <!-- Perguntas  -->
  <section *ngIf="mostrarDS">
    <div class="documento-aditivo-container espacamento-mobile">
      <app-header-documento-final-proposta
        [entidadeProposta]="entidadeProposta"
        [razaoSocialEntidade]="razaoSocialEntidade"
        [codigoProposta]="codigoProposta"
        [vigenciaProposta]="vigenciaProposta"
        [operadoraVM]="operadoraVM"
        [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>

      <p class="mb-1">
        Nome do beneficiário titular:
        <b>{{ nomeTitular }}</b>
      </p>
      <div class="card mt-1 mb-5">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-bordered text-center">
              <thead>
                <tr>
                  <th class="bold-preto-400" style="text-align: left; color: black">
                    <b>(S) Sim (N) Não</b>
                    - Em caso de resposta afirmativa, descreva no quadro de especificações.
                  </th>
                  <th *ngIf="temRespostasTitular()">Tit.</th>
                  <th *ngFor="let dep of getDependentesComRespostas()">Dep. {{ dep.numero }}</th>
                </tr>
              </thead>
              <tbody>
                <!-- Perguntas -->
                <tr *ngFor="let pergunta of perguntasDeclaracaoSaude; let idx = index">
                  <td class="text-left">{{ idx + 1 }} - {{ pergunta.questionText }}</td>
                  <!-- Resposta do titular -->
                  <td *ngIf="temRespostasTitular()">
                    <ng-container *ngIf="idx + 1 === 27 || idx + 1 === 28; else normalResposta">
                      {{ getResposta(idx + 1, 0) }}
                    </ng-container>
                    <ng-template #normalResposta>
                      {{ getResposta(idx + 1, 0) }}
                    </ng-template>
                  </td>
                  <!-- Respostas dos dependentes -->
                  <td *ngFor="let dep of getDependentesComRespostas(); let depIdx = index">
                    <ng-container *ngIf="idx + 1 === 27 || idx + 1 === 28; else normalRespostaDep">
                      {{ getResposta(idx + 1, dep.index + 1) }}
                    </ng-container>
                    <ng-template #normalRespostaDep>
                      {{ getResposta(idx + 1, dep.index + 1) }}
                    </ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Termo  -->
  <section *ngIf="mostrarDS">
    <div class="documento-aditivo-container espacamento-mobile alinhamento-texto-mobile">
      <app-header-documento-final-proposta
        [entidadeProposta]="entidadeProposta"
        [razaoSocialEntidade]="razaoSocialEntidade"
        [codigoProposta]="codigoProposta"
        [vigenciaProposta]="vigenciaProposta"
        [operadoraVM]="operadoraVM"
        [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>

      <h3 class="titulo text-center bold-preto-700 mb-1 p-1" style="background: #ccc; border-radius: 10px">
        Opção para Doenças e/ou Lesões Pré-existentes
      </h3>
      <div class="col-md-12 col-sm-12 mt-1">
        <p>
          Havendo declaração de doenças ou lesões preexistentes e tendo sido orientado, estou ciente da Cobertura
          Parcial Temporária (CPT) – período ininterrupto de 24 meses em que estará suspensa a cobertura de
          Procedimentos de Alta Complexidade (PAC), leitos de alta tecnologia e procedimentos cirúrgicos relacionados às
          doenças e lesões pré-existentes.
        </p>
      </div>
      <p class="titulo bold-preto-700 mt-1 mb-1 p-1 border" style="background: #ccc; margin-bottom: 0px !important">
        Caso algum dos Beneficiários apresente resposta(s) afirmativa(s), favor especificar abaixo, informando datas,
        tratamentos, situação atual e tudo que for importante para avaliação médica.
      </p>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Beneficiário Nº</th>
              <th>Item</th>
              <th>Data Evento</th>
              <th>Especificações</th>
              <th>USO OPERADORA Código CID</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let respostas of respostasPositivasDS; let i = index">
              <td>{{ respostas.tipoBeneficiario }}</td>
              <td>{{ respostas.item }}</td>
              <td>{{ respostas.dataEvento }}</td>
              <td>{{ respostas.especificacoes }}</td>
              <td>{{ respostas.cid }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-12 col-sm-12 mt-1" *ngFor="let grupo of getAgrupamentoBeneficiarioPorDS()">
        <ng-container *ngIf="grupo.valor">
          <p *ngIf="grupo.nomes.length === 1">
            Eu,
            <span class="bold-preto-700" style="color: black">{{ grupo.nomes[0] }}</span>
            , declaro ainda que:
          </p>

          <p *ngIf="grupo.nomes.length > 1">
            Nós,
            <span class="bold-preto-700" style="color: black">{{ grupo.nomes.join(', ') }}</span>
            , declaramos ainda que:
          </p>

          <div class="card-content col-md-12 col-sm-12 mt-1">
            <div class="form-group mb-1 col-sm-12 col-md-12 declaracao-options">
              <div class="row option-row">
                <label class="checkbox-container">
                  <input type="radio" class="hidden-checkbox" [checked]="grupo.valor === '1'" disabled />
                  <span class="checkmark"></span>
                  <span class="option-text">
                    Fui orientado por médico cooperado à UNIMED FESP no preenchimento da declaração de saúde;
                  </span>
                </label>
              </div>
              <div class="row option-row">
                <label class="checkbox-container">
                  <input type="radio" class="hidden-checkbox" [checked]="grupo.valor === '2'" disabled />
                  <span class="checkmark"></span>
                  <span class="option-text">
                    Fui orientado por um médico particular, no preenchimento da declaração de saúde, arcando com o ônus
                    da consulta;
                  </span>
                </label>
              </div>
              <div class="row option-row">
                <label class="checkbox-container">
                  <input type="radio" class="hidden-checkbox" [checked]="grupo.valor === '3'" disabled />
                  <span class="checkmark"></span>
                  <span class="option-text">
                    Entendi o conteúdo de todas as perguntas da declaração de saúde e dispensei a orientação médica para
                    respondê-las, assumindo total responsabilidade pelas informações por mim prestadas.
                  </span>
                </label>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <!-- <div class="doc-footer border mb-5" style="border-radius: 10px; padding: 0.5rem">
      <p>
        <b>Assinatura do beneficiário titular:</b>
      </p>
      <p>
        Assinatura via área logada pelo beneficiário {{ nomeTitular }} em {{ dataAssinaturaDS }} às
        {{ horaAssinaturaDS }}, comercialização através da corretora {{ nomeCorretora }} e vendedor {{ nomeVendedor }},
        conforme Art. 7º da RN 413
      </p>
      <p>Data de preenchimento da proposta: {{ dataAssinaturaDS }}</p>
    </div> -->
      <app-assinatura-documento
        [nomeTitular]="nomeTitular"
        [dataAssinatura]="dataAssinaturaDS"
        [horaAssinatura]="horaAssinaturaDS"
        [nomeCorretora]="nomeCorretora"
        [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
    </div>
  </section>
</ng-container>
<!-- Informações  -->
<section>
  <div class="documento-aditivo-container espacamento-mobile alinhamento-texto-mobile">
    <div class="nova-pagina">
      <app-header-documento-final-proposta
        [entidadeProposta]="entidadeProposta"
        [razaoSocialEntidade]="razaoSocialEntidade"
        [codigoProposta]="codigoProposta"
        [vigenciaProposta]="vigenciaProposta"
        [operadoraVM]="operadoraVM"
        [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
    </div>

    <h3 class="titulo text-center bold-preto-700 mb-1 p-1" style="background: #ccc; border-radius: 10px">
      Informo, para diversos fins e efeitos, que:
    </h3>
    <ul>
      <li>
        <p class="m-2">
          * Autorizo a CONTRATADA solicitar, a qualquer tempo, á médicos, hospitais, clínicas, laboratórios, exames,
          prontuários e informações necessárias para a elucidação de qualquer assunto que se relacione com o presente
          contrato. Isentando-os desde já, de qualquer responsabilidade que implique ofensa ao sigilo profissional.
        </p>
      </li>
      <li>
        <p class="m-2">
          * As informações de saúde relativas à minha pessoa e a meus dependentes são verdadeiras e completas e foram
          espontaneamente fornecidas, estando ciente de que a omissão de fatos e/ou o preenchimento incorreto da
          Declaração de Saúde poderá ser considerada como conduta inaceitável, implicando a minha pessoa, a
          responsabilidade pelo pagamento de despesas efetuadas com a assistência médica e hospitalar com obstetrícia e
          também o cancelamento total da minha presente adesão, a qualquer tempo.
        </p>
      </li>
      <li>
        <p class="m-2">
          *
          <b>
            Preenchi a Declaração de Saúde de todos os dependentes/agregados neste ato, mas sendo meus
            dependentes/agregados maiores que 15 (quinze) anos, comprometo-me a investigar as informações com os mesmos
            e, havendo necessidade de alteração, apresentarei as mesmas por escrito no prazo de 7 (sete) dias contatos a
            partir da data de assinatura desta, sob pena de não atendimento ou exclusão do dependente/agregado com
            Declaração de Saúde inadequada e até mesmo, rescisão, caso apurada a omissão.
          </b>
        </p>
      </li>
      <li>
        <p class="m-2">
          * Tenho o conhecimento de que as informações ora prestadas deverão ser completas e exatas, sob pena de
          inviabilizar a aceitação da presente proposta.
        </p>
      </li>
    </ul>
    <!-- <div class="doc-footer border mb-5" style="border-radius: 10px; padding: 0.5rem">
      <p>
        <b>Assinatura do beneficiário titular:</b>
      </p>
      <p>
        Assinatura via área logada pelo beneficiário {{ nomeTitular }} em {{ dataAssinaturaDocFinal }} às
        {{ horaAssinaturaDocFinal }}, comercialização através da corretora {{ nomeCorretora }} e vendedor
        {{ nomeVendedor }}, conforme Art. 7º da RN 413
      </p>
      <p>Data de preenchimento da proposta: {{ dataAssinaturaDocFinal }}</p>
    </div> -->
    <app-assinatura-documento
      [nomeTitular]="nomeTitular"
      [dataAssinatura]="dataAssinaturaDocFinal"
      [horaAssinatura]="horaAssinaturaDocFinal"
      [nomeCorretora]="nomeCorretora"
      [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
  </div>
</section>
<!-- Orientação da Portabilidade -->
<section *ngIf="mostrarOrientacaoPortabilidade">
  <app-orientacao-portabilidade-sumula-proposta
    [razaoSocialEntidade]="razaoSocialEntidade"
    [entidadeProposta]="entidadeProposta"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [mostrarOrientacaoPortabilidade]="mostrarOrientacaoPortabilidade"></app-orientacao-portabilidade-sumula-proposta>

  <app-assinatura-documento
    [ehTitular]="false"
    [nomeTitular]="nomeTitular"
    [dataAssinatura]="dataAssinaturaOrientacaoPortabilidade"
    [horaAssinatura]="horaAssinaturaOrientacaoPortabilidade"
    [nomeCorretora]="nomeCorretora"
    [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
</section>
<!-- Orientação da Súmula 21 -->
<section *ngIf="mostrarOrientacaoSumula">
  <app-orientacao-portabilidade-sumula-proposta
    [razaoSocialEntidade]="razaoSocialEntidade"
    [entidadeProposta]="entidadeProposta"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [mostrarOrientacaoSumula]="mostrarOrientacaoSumula"></app-orientacao-portabilidade-sumula-proposta>

  <app-assinatura-documento
    [ehTitular]="false"
    [nomeTitular]="nomeTitular"
    [dataAssinatura]="dataAssinaturaOrientacaoSumula"
    [horaAssinatura]="horaAssinaturaOrientacaoSumula"
    [nomeCorretora]="nomeCorretora"
    [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
</section>
<!-- Aditivo Súmula 21 e Portabilidade -->
<section *ngFor="let beneficiario of getBeneficiariosComSumula21EPortabolidade()">
  <app-documento-aditivo
    [nomeTitular]="beneficiario.name"
    [codigoProposta]="codigoProposta"
    [entidadeProposta]="entidadeProposta"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [tipoProposta]="beneficiario.proposalType"
    [vigenciaProposta]="vigenciaProposta"
    [operadoraVM]="operadoraVM"
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho">
    >
  </app-documento-aditivo>

  <app-assinatura-documento
    [ehTitular]="false"
    [nomeTitular]="nomeTitular"
    [nomeCorretora]="nomeCorretora"
    [nomeVendedor]="nomeVendedor"
    [dataAssinatura]="
      getDataHoraAssinatura(
        beneficiario,
        beneficiario.proposalType === TipoPropostaEnum.SUMULA ? 'SUMULA' : 'PORTABILIDADE'
      ).data
    "
    [horaAssinatura]="
      getDataHoraAssinatura(
        beneficiario,
        beneficiario.proposalType === TipoPropostaEnum.SUMULA ? 'SUMULA' : 'PORTABILIDADE'
      ).hora
    "></app-assinatura-documento>
</section>
<!-- Redução de Carencias -->
<section>
  <app-reducao-carencia-proposta
    [dadosOperadoraDM]="dadosOperadoraDM"
    [dataCriacaoProposta]="dataCriacaoProposta"
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
    [entidadeProposta]="entidadeProposta"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [mostrarQuadroDoisReducaoCarencia]="mostrarQuadroDoisReducaoCarencia"
    [listaBeneficiariosCarencias]="listaBeneficiariosCarencias"
    [heMedSenior]="heMedSenior"
    [nomeTitular]="nomeTitular"></app-reducao-carencia-proposta>
  <div class="texto-rodade-assinatura">
    <app-assinatura-documento
      [nomeTitular]="nomeTitular"
      [dataAssinatura]="dataAssinaturaReducaoCarencia"
      [horaAssinatura]="horaAssinaturaReducaoCarencia"
      [nomeCorretora]="nomeCorretora"
      [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
  </div>
</section>

<!-- Email Declinio Proposta -->
<section *ngIf="statusProposta">
  <app-emails-declinio-proposta
    [tipoPropostaDeclinada]="tipoDeclinio"
    [dataDeclinio]="dataDeclinio"
    [horaDeclinio]="horaDeclinio"
    [motivoDeclinio]="motivoDeclinio"
    [nomeTitular]="nomeTitular"
    [codigoProposta]="codigoProposta"
    [motivoDeclinio]="motivoDeclinio"></app-emails-declinio-proposta>
</section>

<!-- formulario cadastro entidade -->
<ng-container
  *ngIf="
    (entidadeProposta == 'ADSERVIP' || entidadeProposta == 'ABJE') && !this.dadosOperadoraCabecalho.ehInclusaoDependente
  ">
  <section *ngIf="existeFormularioEntidade && !dadosProstaCompletos?.externalRegistrationLink">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
    <app-formulario-inscricao-entidade-adservip
      *ngIf="this.entidadeProposta === 'ADSERVIP'"
      [formEntidadeSomenteLeitura]="true"
      [retornoDadosFormularioEntidade]="retornoDadosFormularioEntidade"></app-formulario-inscricao-entidade-adservip>
    <app-formulario-inscricao-entidade-abje
      *ngIf="this.entidadeProposta === 'ABJE'"
      [formEntidadeSomenteLeitura]="true"
      [retornoDadosFormularioEntidade]="retornoDadosFormularioEntidade"
      [logoEntidade]="null"
      [nomeEntidade]="entidadeProposta"></app-formulario-inscricao-entidade-abje>
    <app-assinatura-documento
      [nomeTitular]="nomeTitular"
      [dataAssinatura]="dataAssinaturaDadosBancarios"
      [horaAssinatura]="horaAssinaturaDadosBancarios"
      [nomeCorretora]="nomeCorretora"
      [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
  </section>
</ng-container>

<!-- Documentos Beneficiário -->
<section>
  <div class="nova-pagina">
    <app-lista-documentos-proposta
      [dadosOperadoraDM]="dadosOperadoraDM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [entidadeProposta]="entidadeProposta"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [beneficiariosComDocumentos]="beneficiariosComDocumentos"></app-lista-documentos-proposta>
  </div>
</section>
